import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/products`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/products/${id}?include=organization,allowedLocations,categories,taxGroups,unitOfMeasure,orderUnitOfMeasureUnit,replacements`,
      options
    )
    .then((response) => {
      let product = jsona.deserialize(response.data);
      delete product.links;
      return product;
    });
}

function add(product) {
  const payload = jsona.serialize({
    stuff: product,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/products?include=organization,allowedLocations,categories,taxGroups,unitOfMeasure,orderUnitOfMeasureUnit,replacements`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(product) {
  const payload = jsona.serialize({
    stuff: product,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(
      `${url}/products/${product.id}?include=organization,allowedLocations,categories,taxGroups,unitOfMeasure,orderUnitOfMeasureUnit,replacements`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/products/${id}`, options);
}

function activate(id) {
  
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };
  
  return axios
    .get(
      `${url}/products/${id}/activate?include=organization,allowedLocations,categories,taxGroups,unitOfMeasure,orderUnitOfMeasureUnit,replacements`,
      options
    )
    .then((response) => {
      let product = jsona.deserialize(response.data);
      delete product.links;
      return product;
    });
}

function deactivate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/products/${id}/deactivate?include=organization,allowedLocations,categories,taxGroups,unitOfMeasure,orderUnitOfMeasureUnit,replacements`,
      options
    )
    .then((response) => {
      let product = jsona.deserialize(response.data);
      delete product.links;
      return product;
    });
}

function setBackorder(params) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/products/${params.id}/set-backorder?include=organization,allowedLocations,categories,taxGroups,unitOfMeasure,orderUnitOfMeasureUnit,replacements`,
      params,
      options
    )
    .then((response) => {
      let product = jsona.deserialize(response.data);
      delete product.links;
      return product;
    });
}

function getProductUnitOfMeasureUnitPrice({ id, unitOfMeasureUnit }) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/products/${id}/unit-of-measure-unit-price?unitOfMeasureUnit=${unitOfMeasureUnit}`,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  activate,
  deactivate,
  setBackorder,
  getProductUnitOfMeasureUnitPrice,
};
